import { forwardRef, useRef } from "react";
/* eslint-disable-next-line no-restricted-imports */
import { OverlayProps } from "react-bootstrap";
import { Overlay } from "./MksapReactBootstrap";

export const InlineOverlay = forwardRef<
	HTMLElement,
	Omit<OverlayProps, "container">
>((props, ref) => {
	const containerRef = useRef<HTMLDivElement>(null);
	return (
		<>
			<Overlay {...props} ref={ref} container={containerRef} />
			{/* Using a span here which admittedly is weird. The span allows us
			to use the inline overlay in paragraph elements without run time
			warnings/errors */}
			<span ref={containerRef} />
		</>
	);
});
